import { render } from "./manage-footer-photo.vue?vue&type=template&id=72d656ee"
import script from "./manage-footer-photo.vue?vue&type=script&lang=js"
export * from "./manage-footer-photo.vue?vue&type=script&lang=js"

import "./manage-footer-photo.vue?vue&type=style&index=0&id=72d656ee&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__